import React, { useState, useEffect } from "react";
import { Redirect, withRouter } from "react-router-dom";
import { Ast, ModalConfirmPP, beforeUpload, valueUpperCase, getUrl } from "../../../../utils/Organitation/function";
import { Alert, Button, Checkbox, Col, Input, Modal, Radio, Row, Select, Upload, message, Form } from "antd";
import { PaperClipOutlined, UploadOutlined } from "@ant-design/icons";
import { RFC, apellidos, calleOrganizacion, cpOrganizacion, nombres, numeroInt, required, soloDigitos, soloTexto, tel } from "../../../../utils/rules";
import { getEntidadPP, getMunicipiosPP, getTypeOrganitationPP, getOrganitationViewUpdPP, getDownloadPP } from "../../../../api/organitation";
import { ID_PUESTO_ORG_ELECTORAL, ID_PUESTO_PRESIDENTE, MSN_GUARDAR } from "../../../../utils/constanst";
import { txtNombre, txtOrg } from "../../../../utils/regex";
import { validaRepre } from "../../../../utils/Organitation/function";
import useAuth from "../../../../hooks/useAuth";
import { URL_ORGANIZACION } from "../../../../api/config";
import { saveAs } from "file-saver";
import { getFuncionariosPP } from "../../../../api/courses";

function RegOrg(props) {

  const {history, setLoader, location: { state, modificar, consulta }} = props; //Para utilizar la función push

  const { ciudadano: { ciudadano } } = useAuth();

  const [form] = Form.useForm();

  const { Option } = Select;
  const [tipoOrg, setTipoOrg] = useState([]);
  const [disabled, setDisabled] = useState({input: false, chkSinNum: false});
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [document, setDocument] = useState([{ file: [], nameFile: "", url: "" }]); //Se almacena el archivo
  const [btnGuardar, setBtnGuardar] = useState(false);
  const [btnFile, setBtnFile] = useState(true);
  const [document2, setDocument2] = useState([
    { file: [], nameFile: "", url: "" },
  ]); //Se almacena el archivo

  useEffect(() => {

    setLoader({ loading: true, message: MSN_GUARDAR }); //Se activa el loader
    getTypeOrganitationPP().then((res) => {
      setTipoOrg(res.data);
    });

    getEntidadPP().then((res) => {
      setEstados(res.data);
    });

    if (ciudadano.id !== null) {
      getOrganitation();
    }

    setLoader({ loading: false, message: "" }); //Se desactiva el loader
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Se valida que acceda desde la pantalla principal
  if (state === undefined) {
    return (
      <>
        <Redirect to="/organizacion/inicio" />
      </>
    );
  }

  //Llena el formulario si recibe una organización
  const getOrganitation = () => {

    setLoader({ loading: true, message: MSN_GUARDAR });

    getOrganitationViewUpdPP(true, ciudadano.idProceso, 0, ciudadano.id).then((response) => {

        //console.log('Organización-->', response.data);

        if (!response.data.voOrganizacion.urlSolicitud) {
          setDocument([{ nameFile: "" }]);
          setBtnFile(true);
        } else {
          let nameFile = getUrl(response.data.voOrganizacion.urlSolicitud, URL_ORGANIZACION);
          setDocument2([{ nameFile: nameFile, url: response.data.voOrganizacion.urlSolicitud }]);
          setBtnFile(false);
        }

        getMunicipiosPP(response.data.voOrganizacion.idEstado).then((res) => {
          setMunicipios(res.data);
        });

        form.setFieldsValue({
          //Se llenan los input del formulario
          idOrganizacion: response.data.voOrganizacion.idOrganizacion,
          //tipo: data.cTiposOrganizacion.idTipoOrganizacion,
          tipo: response.data.voOrganizacion.idTipoOrganizacion,
          idEstado: response.data.voOrganizacion.idEstado,
          organizacion: response.data.voOrganizacion.organizacion,
          siglas: response.data.voOrganizacion.siglasOrg,
          reprePaterno: response.data.voOrganizacion.apellidoPaternoRepre,
          repreMaterno: response.data.voOrganizacion.apellidoMaternoRepre,
          repreNombre: response.data.voOrganizacion.nombreRepre,
          rfc: response.data.voOrganizacion.rfcOrg,
          apoyo: response.data.voOrganizacion.banderaApoyo,
          telefono: response.data.voOrganizacion.telefono != null ? response.data.voOrganizacion.telefono.toString() : "",
          correo: response.data.voOrganizacion.correoElectronico,
          calle: response.data.voOrganizacion.calle,
          numeroExterior: response.data.voOrganizacion.numeroExterior,
          numeroInterior: response.data.voOrganizacion.numeroInterior,
          colonia: response.data.voOrganizacion.colonia,
          codigoPostal: (response.data.voOrganizacion.codigoPostal==null ? "": response.data.voOrganizacion.codigoPostal.toString()),
          idMunicipio: response.data.voOrganizacion.idMunicipio,
        });
        
        if (response.data.voOrganizacion.numeroExterior===null&& response.data.voOrganizacion.numeroInterior===null) {
          //Aca va acitvar el chk de sin número
          setDisabled({ chkSinNumero: true, checkNum: true, title: true })
        }

        if ( response.data.voOrganizacion.codigoPostal!==null && 
             response.data.voOrganizacion.codigoPostal!=="" && 
             response.data.voOrganizacion.codigoPostal.toString().length < 5 ) {

          var faltanteCP = 5 - response.data.voOrganizacion.codigoPostal.toString().length;
          var finalCP = response.data.voOrganizacion.codigoPostal.toString();
          for (let i = 0; i < faltanteCP; i++) {
            finalCP = "0" + finalCP;
          }
          form.setFieldsValue({
            codigoPostal: finalCP.toString(),
          });
        }

        //Damos formato al telefono si se capturo ceros al inicio 
        if (response.data.voOrganizacion.telefono && response.data.voOrganizacion.telefono.toString().length < 10) {
          var faltanteTel = 10 - response.data.voOrganizacion.telefono.toString().length;
          var finalTel = response.data.voOrganizacion.telefono.toString();
          for (let i = 0; i < faltanteTel; i++) {
              finalTel = "0" + finalTel;
          }
          form.setFieldsValue({
              telefono: finalTel,
          });
        }
      
      setLoader({ loading: false, message: "" });

    }).catch((error) => {
      console.log(error);
      setLoader({ loading: false, message: "" });
    });
  };

  const AlertLastName = () => {
    return (
      <>
      <Row>
        <Col span={24}>
          <Alert message="Al menos uno de los dos apellidos es obligatorio." 
                type="info" 
                showIcon />
        </Col>
      </Row><br/>
      </>
    );
  };

  const desactivarCarga= () =>{
    console.log('Se carga el archivo');
  }

  //Función que descarga un documento
  const download = (url, name) => {

    setLoader({ loading: true, message: MSN_GUARDAR }); //Se activa el loader

    const json = {
      url: url,
      nombre: name,
    };

    getDownloadPP(json).then((res) => {

      if (res.data) {
        saveAs(new Blob([res.data]), name);
      }

      setLoader({ loading: false }); //Se activa el loader

    }).catch((error) => {
      setLoader({ loading: false }); //Se activa el loader
      message.error("El archivo no se encuentra disponible");
    });
  };
  
  const onChangeSinNumero = (e) => {
    if (e.target.checked) {
      setDisabled({ ...disabled, chkSinNum: true });
      form.setFieldsValue({ numeroExterior: "" });
      form.setFieldsValue({ numeroInterior: "" });
    } else {
      setDisabled({ ...disabled, chkSinNum: false });
    }
  };

  const onChangeEstado = (e) => {
    setLoader({ loading: true, message: MSN_GUARDAR }); //Se activa el loader
    form.setFieldsValue({ idMunicipio: undefined });
    getMunicipiosPP(e).then((res) => {
      setMunicipios(res.data);
      setLoader({ loading: false, message: "" }); //Se desactiva el loader
    });
  };

  //Validaciones para cargar el archivo
  const file = {
    name: "file",
    multiple: false,
    showUploadList: {
      showDownloadIcon: false,
    },
    onRemove: (file) => {
      setDocument((state) => {
        return {
          file: [],
        };
      });
    },

    beforeUpload: (file) => {
      if (beforeUpload(file)) {
        setDocument((state) => ({
          file: [file],
        }));
      }
      return false;
    },
    document,
  };

  //Función que regresa a la pagina de tipo de solicitud
  const back = () => {
    history.push("/organizacion/inicio");
  };

  //Función que registra la organización 
  const addOrganitation = () => {

    form.validateFields().then((values) => {

        let repre = validaRepre(values.reprePaterno, values.repreMaterno);
        let correosVocales = [];
        let correosVocalesStr;
        if(repre) {

          values.idProcesoElectoral = ciudadano.idProceso;
          values.idDetalleProceso = 0; //Se manda 0 porque las org se registran a nivel proceso electoral (OC)
          values.usuario = ciudadano.sub;
          values.correo = ciudadano.sub;
          values.idCuenta = ciudadano.idCuenta;
          
          getFuncionariosPP(values.idProcesoElectoral, values.idDetalleProceso, values.idEstado, 0).then((res) => {
              if(res.data.integrantes !== undefined) {
                for (let i = 0; i < res.data.integrantes.length; i++) {
                  if (res.data.integrantes[i].idPuesto === ID_PUESTO_PRESIDENTE || 
                    res.data.integrantes[i].idPuesto === ID_PUESTO_ORG_ELECTORAL) {
                      correosVocales.push(res.data.integrantes[i].correoElectronico);
                  }
                }
                correosVocalesStr = correosVocales.join(',');
              }
              values.correosVocales=correosVocalesStr;
              setBtnGuardar(true);
              console.log('values-->',values);

              ModalConfirmPP(values, document, history, setBtnGuardar, setLoader, ciudadano, modificar);
          }).catch((error) => {
              console.log("Error al obtener los funcionarios para el envío de correo");
          });

        } else {

          Modal.warning({
            title: "Atención",
            content: "Al menos uno de los dos apellidos es obligatorio.",
          });

        }
    }).catch((error)=>{
      message.info("Los datos con ( * ) son requeridos.");
    });
  };

  return (

    <div style={{ marginTop: 20 }}>

      <h1>Solicitud</h1>
      <hr />

      <p style={{ marginTop: 30 }}>
        Los datos marcados con ( <Ast /> ) son obligatorios
      </p>

      <h3>Datos de la organización</h3>

      <Form form={form} layout="vertical">

        <Form.Item name="idOrganizacion" >
          <Input disabled hidden />
        </Form.Item>

        <Row>
          <Col span={24}>

            <Form.Item  label="Tipo de organización"
                        name="tipo"
                        rules={ required } >

              <Select disabled={consulta} 
                      placeholder="Selecciona" 
                      style={{ width: 315 }}>

                {tipoOrg.map((item) => (
                  <Option key={item.idTipoOrganizacion} value={item.idTipoOrganizacion}>
                    {item.tipoOrganizacion}
                  </Option>
                ))}
              </Select>

            </Form.Item>

          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={16}>

            <Form.Item  label="Nombre de la organización"
                        name="organizacion"
                        rules={ soloTexto }
                        getValueFromEvent={ (event) => {
                            return txtOrg.test(event.target.value)
                              ? event.target.value.replace("-", "")
                              : event.target.value.slice(0, -1);
                        }} >

              <Input  disabled={consulta} 
                      placeholder="Nombre completo sin abreviaturas"
                      maxLength={100} />

            </Form.Item>

          </Col>
          <Col span={8}>

            <Form.Item  label="Siglas"
                        name="siglas"
                        rules={ apellidos } >

              <Input disabled={consulta} 
                      placeholder="Siglas" 
                      maxLength={50} />

            </Form.Item>

          </Col>
        </Row>

        <Row>
          <Col span={24}>

            <Form.Item  label="RFC de la organización"
                        name="rfc"
                        rules={RFC} 
                        getValueFromEvent={ valueUpperCase} >

              <Input  disabled={consulta} 
                      placeholder="13 caracteres"
                      style={{ width: 315 }} 
                      maxLength={13} />

            </Form.Item>

          </Col>
        </Row>

        <p><Ast /> Representante legal</p>

        {!consulta ?<AlertLastName />:<></>}

        <Row gutter={20}>
          <Col span={8}>

            <Form.Item  label="Apellido paterno"
                        name="reprePaterno"
                        rules={ apellidos }
                        getValueFromEvent={ (event) => {
                          return txtNombre.test(event.target.value)
                            ? event.target.value.replace("-", "")
                            : event.target.value.slice(0, -1);
                        }} >

              <Input  disabled={consulta} 
                      placeholder="Apellido paterno"
                      maxLength={40} />
            </Form.Item>

          </Col>
          <Col span={8}>

            <Form.Item  label="Apellido materno"
                        name="repreMaterno"
                        rules={ apellidos }
                        getValueFromEvent={ (event) => {
                          return txtNombre.test(event.target.value)
                            ? event.target.value.replace("-", "")
                            : event.target.value.slice(0, -1);
                        }} >

              <Input  disabled={consulta} 
                      placeholder="Apellido materno"
                      maxLength={40} />

            </Form.Item>

          </Col>
          <Col span={8}>

            <Form.Item  label="Nombre(s)"
                        name="repreNombre"
                        rules={ nombres }
                        getValueFromEvent={ (event) => {
                          return txtNombre.test(event.target.value)
                            ? event.target.value.replace("-", "")
                            : event.target.value.slice(0, -1);
                        }} >

              <Input  disabled={consulta} 
                      placeholder="Nombre(s)" 
                      maxLength={50} />

            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>

            <Form.Item  label="¿La organización solicita apoyo económico?"
                        name="apoyo" >

              <Radio.Group disabled={consulta}>
                <Radio value={1}>Sí</Radio>
                <Radio value={0}>No</Radio>
              </Radio.Group>

            </Form.Item>

          </Col>
        </Row>
        <h3>Domicilio</h3>
        <Row gutter={20}>
          <Col span={8}>
            <Form.Item label="Calle"
              name="calle"
              rules={ calleOrganizacion }
            >
                <Input disabled={consulta} maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={4} style={{paddingLeft: 40, paddingTop: 40}}>
            <Form.Item
              name="sinNumero"
              valuePropName="checked"
            >
                <Checkbox  disabled={consulta} onChange={onChangeSinNumero}>
                  Sin número
                </Checkbox>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
              label="No. exterior"
              name="numeroExterior"
              getValueFromEvent={ (event) => {
                  return numeroInt.test(event.target.value)
                    ? event.target.value
                    : (event.target.value).slice(0, -1);
                }}
              >
                <Input maxLength={20}  disabled={disabled.chkSinNum||consulta} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
              label="No. interior"
              name="numeroInterior"
              getValueFromEvent={ (event) => {
                return numeroInt.test(event.target.value)
                  ? event.target.value
                  : (event.target.value).slice(0, -1);
              }}
            >
                <Input maxLength={20} disabled={disabled.chkSinNum||consulta} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={8}>
            <Form.Item 
              label="Colonia" 
              name="colonia"
              rules={ calleOrganizacion }
            >
                <Input disabled={consulta} maxLength={40} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item 
              label="Código postal" 
              name="codigoPostal"
              rules={ cpOrganizacion }
              getValueFromEvent={ (event) => {
                return soloDigitos.test(event.target.value)
                  ? event.target.value
                  : (event.target.value).slice(0, -1);
              }}
            >
                <Input disabled={consulta} maxLength={5} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Estado"
              name="idEstado" 
              rules={ required }
            >
                <Select disabled={consulta} placeholder="Selecciona"
                  onChange={onChangeEstado}
                >
                  {estados.map((item) => (
                    <Option key={item.id.idEstado} value={item.id.idEstado}>
                      {item.nombreEstado}
                    </Option>
                  ))}
                </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
              label="Municipio"
              name="idMunicipio"
            >
                <Select disabled={consulta} placeholder="Selecciona">
                  {municipios.map((item) => (
                    <Option key={item.idMunicipio} value={item.idMunicipio}>
                      {item.municipio}
                    </Option>
                  ))}
                </Select>
            </Form.Item>
          </Col>
        </Row>
        <h3>Datos de contacto</h3>
        <Row>
          <Col span={4}>
            <Form.Item 
              label="Teléfono"
              name="telefono" 
              rules={ tel }
              getValueFromEvent={ (event) => {
                return soloDigitos.test(event.target.value)
                  ? event.target.value
                  : event.target.value.slice(0, -1);
              }}
            >
                <Input disabled={consulta} placeholder="10 dígitos" maxLength={10}/>
            </Form.Item>
          </Col>
        </Row>
        <p>Soporte documental que sustente la solicitud</p>
        <Row hidden={consulta}>
          <Col span={24}>
            <Alert
              message="Algún documento que avale la legitimidad del trámite o de la organización que solicita el registro. Formato pdf que no exceda los 6MB."
              type="info" showIcon
            />
          </Col>
        </Row>
        <Row style={{paddingTop: 20}}>
          <Col span={24}>
          {btnFile ? (
            <Form.Item style={{ marginTop: 20 }}>
              <Upload
                {...file}
                accept=".pdf,.PDF"
                fileList={document.file}
                disabled={disabled.input||consulta}
              >
                <Button type="default" disabled={disabled.input||consulta}>
                  <UploadOutlined />
                  Cargar
                </Button>
              </Upload>
            </Form.Item>
         ) : (
          <div style={{ marginTop: 20 }}>
            <button
              className="btnDownload"
              onClick={(e) =>
                download(document2[0].url, document2[0].nameFile, e)
              }
            >
              <PaperClipOutlined />
              {document2[0].nameFile}
            </button>
            <Form.Item style={{ marginTop: 20 }}>
              <Upload
                {...file}
                accept=".pdf,.PDF"
                fileList={document.file}
                onClick={() => desactivarCarga()}
                disabled={disabled.input||consulta}
                
              >
                <Button type="default" disabled={disabled.input||consulta}>
                  <UploadOutlined />
                  Cargar
                </Button>
              </Upload>
            </Form.Item>
          </div>
        )}
          </Col>
        </Row>
        <Row>
          <Col span={24} style={{textAlign: "center"}}>
            <Form.Item>
            {!consulta?
              <Button type="default" onClick={back}>
                Cancelar
              </Button>:<></>}
              {!modificar && !consulta?
              <Button type="primary" onClick={ addOrganitation }
                disabled={btnGuardar}
              >
                Guardar
              </Button>:<></>}
              {modificar?
              <Button type="primary" onClick={addOrganitation}
                disabled={btnGuardar} style={{ width: 'auto' }}
              > 
                 Modificar datos de la organización
              </Button>
              :<></>}
              {consulta?
              <Button type="default" onClick={back}>
                Regresar
              </Button>:<></>}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
const regOrgForm = (RegOrg)
export default withRouter(regOrgForm);
